'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';
import uiBootstrap from 'angular-ui-bootstrap';

export class DynamicComponent {

  component;

  constructor($scope, $compile, $element) {
    'ngInject';

    this.element = $element;
    this.compile = $compile;
    this.scope   = $scope;
  }

  $onInit() {
    this.buildComponent();
  }

  buildComponent() {
    // component was initialized
    this.data.initialized = true;
    this.component = this.data.component;

    var prevScope = this.element.children().scope();
    if(prevScope){
      prevScope = null;
    }

    var scope  = this.scope.$new();
    scope.data = this.data;

    // make a view
    var html = '<' + scope.data.component + ' data="data"></' + scope.data.component + '>';

    // clear and append new view
    this.element.empty()
      .append(this.compile(html)(scope));
  }

  $onChanges(changes) {
    if(changes.data && changes.data.previousValue.constructor.name != 'UNINITIALIZED_VALUE') {
      if(this.component != this.data.component){
        this.buildComponent();
      }
    }
  }
}

export default angular.module('directives.dynamic', [uiBootstrap])
  .component('dynamicComponent', {
    bindings: {data: '<'},
    transclude: true,
    controller: DynamicComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/dynamic/dynamic.component.js